<a [href]="link" target="_blank" class="btn-floating">
  {{ label }}
</a>
